import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5500;
const GAP_MS = 12000;

/**
 * Aviso de compra reciente. Solo aparece si data/recentPurchases.ts tiene
 * compras reales cargadas; con el array vacío no renderiza nada.
 */
export function PurchaseNotifications() {
  if (recentPurchases.length === 0) return null;
  return <PurchaseToast data-id="element-306" data-mp="crnlpativcat" />;
}
function PurchaseToast() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timeout = setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        show();
      }, GAP_MS);
    };
    timeout = setTimeout(show, FIRST_DELAY);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  if (dismissed) return null;
  const purchase = recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-307" data-mp="ewgmsofagcmb">
      <AnimatePresence data-id="element-308" data-mp="1cgtf18edzl67">
        {visible && <motion.div key={index} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[320px] max-w-full items-start gap-3 rounded-2xl border border-sand-dark bg-white p-3.5 shadow-card" data-id="element-309" data-mp="17l4byv35rm55">
            <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-ground-soft" data-id="element-310" data-mp="3kruc3frci4kt">
              <CheckIcon className="h-4 w-4 text-ground-deep" aria-hidden="true" data-id="element-311" data-mp="3ppdosb8ea9an" />
            </span>
            <p className="min-w-0 flex-1 text-[13px] leading-snug text-night" data-id="element-312" data-mp="3as3c4yk0mxdc">
              <span className="font-bold" data-id="element-313" data-mp="3fqohtdi1e996">{purchase.name}</span> in{' '}
              {purchase.city}, {purchase.state} just got Acro Yoga Class Ready
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="-mr-1 -mt-1 flex h-7 w-7 flex-none items-center justify-center rounded-full text-night-muted transition-colors duration-150 hover:bg-sand hover:text-night focus:outline-none focus-visible:ring-2 focus-visible:ring-coral" data-id="element-314" data-mp="36qrmwu520e5o">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-315" data-mp="2n3af0yrnqjh5" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}